import { createData, deleteData } from "../api-service";

export type AdminApiKey = {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  token: string;
  user: User;
};

interface User {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: string;
  name: string;
  email: string;
  username: string;
  password: string;
  phoneNumber: string;
}

export const ADMIN_API_KEY_ENDPOINT = "/admin/api-key";

export const adminAPIKeyApi = {
  // Create a new api key
  create: (username: string) =>
    createData<AdminApiKey>(`${ADMIN_API_KEY_ENDPOINT}/${username}`),

  // Delete a api key
  delete: ({ username, id }: { username: string; id: number }) =>
    deleteData(`${ADMIN_API_KEY_ENDPOINT}/${username}`, id),
};
